export default __webpack_public_path__ + "static/media/24.1d0aba23.png";